import React, { Component } from 'react'
import Map from './map'

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }  
  render() {
    return (<>{ this.props.children }</>)
  }
}

class LocationBlock extends Component {

  static defaultProps = {
    googleMap: {
      latitude: -28.030649150971115,
      longitude: 153.43212345767046,
    }
  }
  
  render() {

    let { googleMap } = this.props

    return (
      <section className='location-block'>
        <div className='location-block__inner'>
          <div className='location-block__map'>
            <BlockUpdate>
              <Map lat={googleMap.latitude} lng={googleMap.longitude} zoom={15} staticMap={false} />
            </BlockUpdate>
          </div>
        </div>
      </section>
    )
  }
}

export default LocationBlock
